import { StandardEvents } from '@shopify/events';

document.addEventListener('click', (event) => {
  if (
    event.defaultPrevented ||
    event.button !== 0 ||
    event.metaKey ||
    event.ctrlKey ||
    event.shiftKey ||
    event.altKey ||
    !(event.target instanceof Element)
  ) return;

  const link = event.target.closest('a[data-nf-cart-link]');
  if (!link || (link.target && link.target !== '_self')) return;

  const drawer = document.getElementById('cart-drawer');
  if (!drawer || typeof drawer.open !== 'function') return;

  event.preventDefault();
  drawer.open();
});

let navegacaoIniciada = false;

function atualizarContagem(quantidade) {
  if (!Number.isInteger(quantidade) || quantidade < 0) return;

  document.querySelectorAll('.nf-header[data-nf-cart-url]').forEach((cabecalho) => {
    const contador = cabecalho.querySelector('[ref="cartBubbleCount"]');
    const bolha = cabecalho.querySelector('[ref="cartBubble"]');
    const link = cabecalho.querySelector('.nf-header__cart');
    const regiaoViva = cabecalho.querySelector('[ref="liveRegion"]');
    const termo = quantidade === 1 ? cabecalho.dataset.nfCartItem : cabecalho.dataset.nfCartItems;
    const rotulo = `${cabecalho.dataset.nfCartLabel}: ${quantidade} ${termo}`;

    if (contador) {
      contador.textContent = String(quantidade);
      contador.classList.toggle('hidden', quantidade === 0);
    }
    bolha?.classList.toggle('visually-hidden', quantidade === 0);
    link?.setAttribute('aria-label', rotulo);
    if (regiaoViva) regiaoViva.textContent = rotulo;
  });
}

function redirecionarParaSacola(cabecalho) {
  if (navegacaoIniciada || !cabecalho.dataset.nfCartUrl) return;
  const destino = new URL(cabecalho.dataset.nfCartUrl, window.location.origin);
  if (destino.pathname === window.location.pathname) return;
  navegacaoIniciada = true;
  window.location.assign(destino.href);
}

function mostrarSacola(cabecalho) {
  if (cabecalho.dataset.nfCartType === 'drawer') {
    const gaveta = document.getElementById('cart-drawer');
    if (gaveta?.hasAttribute('open')) return;
    if (gaveta && typeof gaveta.open === 'function') {
      try {
        gaveta.open();
        return;
      } catch {
        redirecionarParaSacola(cabecalho);
        return;
      }
    }
  }
  redirecionarParaSacola(cabecalho);
}

document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
  if (!event.promise || typeof event.promise.then !== 'function') return;

  event.promise.then(({ cart, detail }) => {
    const quantidade = cart?.totalQuantity;
    atualizarContagem(quantidade);

    if (event.action !== 'add' || detail?.didError || !Number.isInteger(quantidade) || quantidade < 1) return;
    const cabecalho = document.querySelector('.nf-header[data-nf-cart-url]');
    if (!cabecalho) return;

    const modalOrigem = event.target instanceof Element ? event.target.closest('dialog[open]') : null;
    if (modalOrigem) {
      modalOrigem.addEventListener('close', () => mostrarSacola(cabecalho), { once: true });
      return;
    }
    mostrarSacola(cabecalho);
  }).catch((erro) => {
    if (erro?.name !== 'AbortError') console.warn('[NatalFamilia] Não foi possível confirmar a atualização da sacola.', erro);
  });
});
